import get from 'lodash.get';
import type {
  StringIndexedObject,
  ValidationConditions,
  ValidationErrors,
} from '@kanda-libs/ks-component-ts';

const flattenObject = (obj) =>
  Object.keys(obj).reduce((flat, val) => {
    if (typeof obj[val] === 'string')
      return {
        ...flat,
        [val]: obj[val],
      };
    return {
      ...flat,
      ...flattenObject(obj[val]),
    };
  }, {});

export const getValidationConditions = (validation): ValidationConditions =>
  Object.keys(validation).reduce(
    (validators, key) => ({
      ...validators,
      [key]: validation[key].value,
    }),
    {},
  );

export const getValidationErrors = (validation): ValidationErrors =>
  Object.keys(validation).reduce((validators, key) => {
    if (typeof validation[key].message === 'string')
      return {
        ...validators,
        [key]: validation[key].message,
      };
    const messages = flattenObject(validation[key].message);
    return {
      ...validators,
      ...messages,
    };
  }, {});

export const validateAddressSelect = (
  formValues: StringIndexedObject,
  addressFieldName: string,
): boolean | null => {
  if (!addressFieldName) return null;
  const address = get(formValues, addressFieldName);
  if (!address) return false;
  const selected = address?.selected;
  const line1 = address?.line_1;
  if (!line1 && !selected) return false;
  if (selected && !line1) return false;
  return true;
};
